import { render, staticRenderFns } from "./PoisValidate.vue?vue&type=template&id=4b46801e&scoped=true&"
import script from "./PoisValidate.vue?vue&type=script&lang=js&"
export * from "./PoisValidate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b46801e",
  null
  
)

export default component.exports